'use client';

import React from 'react';

import { DayPicker } from 'react-day-picker';
import { nl, fr, enUS } from 'react-day-picker/locale';
import styles from './calendar.module.scss';
import Icon from '../Icon/Icon';
import { Button } from '../Button/Button';
import { useTranslation } from 'utils/translation';

type CalendarProps = React.ComponentProps<typeof DayPicker>;

const locales = {
  nl,
  fr,
  en: enUS,
} as const;

function Calendar({ className, classNames, ...props }: CalendarProps) {
  const { i18n } = useTranslation();

  return (
    <DayPicker
      {...props}
      className={styles.calendar}
      locale={locales[i18n.language as keyof typeof locales] || locales.en}
      classNames={{
        months: styles.months,
        month: styles.month,
        caption: styles.caption,
        weekday: styles.weekday,
        caption_label: styles.captionLabel,
        nav: styles.nav,
        nav_button: styles.navButton,
        nav_button_previous: styles.navButtonPrev,
        nav_button_next: styles.navButtonNext,
        table: styles.table,
        head_row: styles.headRow,
        head_cell: styles.headCell,
        row: styles.row,
        cell: styles.cell,
        day: styles.day,
        day_range_start: styles.cellRangeStart,
        day_range_end: styles.cellRangeEnd,
        selected: styles.daySelected,
        day_today: styles.dayToday,
        day_outside: styles.dayOutside,
        day_disabled: styles.dayDisabled,
        day_range_middle: styles.dayRangeMiddle,
        day_hidden: styles.dayHidden,
        day_button: styles.dayButton,
      }}
      components={{
        PreviousMonthButton: ({ className, ...props }: any) => (
          <Button size="xxs" variant="icon" className={className} {...props}>
            <Icon name="fa-regular fa-chevron-left" />
          </Button>
        ),
        NextMonthButton: ({ className, ...props }: any) => (
          <Button size="xxs" variant="icon" className={className} {...props}>
            <Icon name="fa-regular fa-chevron-right" />
          </Button>
        ),
      }}
    />
  );
}

export default Calendar;
